// src/components/modals/ContinueModal.tsx

import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import BaseModal, { modalStyles, HoverButton } from './BaseModal';
import ModalStickyFooter from '../ui/ModalStickyFooter';
import { colors, typography } from '../../styles/theme';

interface ContinueProps {
  visible: boolean;
  onClose: () => void;
  onContinue: () => void;
  onRestart: () => void;
}

export default function ContinueModal({ visible, onClose, onContinue, onRestart }: ContinueProps) {
  return (
    <BaseModal
      visible={visible}
      onClose={onContinue}
      isFullScreenOnMobile={false}
      header={(
        <>
          <Text style={modalStyles.headerText}>Welcome Back!</Text>
          <Text style={modalStyles.subtitleText}>Would you like to continue your puzzle, or restart?</Text>
        </>
      )}
      footer={(
        <ModalStickyFooter style={modalStyles.buttonContainer}>
          <HoverButton
            style={modalStyles.primaryButton}
            hoverStyle={modalStyles.primaryButtonHover}
            textStyle={modalStyles.primaryButtonText}
            onPress={onClose}
          >
            Continue
          </HoverButton>
          <HoverButton
            style={modalStyles.clearButton}
            textStyle={modalStyles.clearButtonText}
            onPress={onRestart}
          >
            Restart
          </HoverButton>
        </ModalStickyFooter>
      )}>
    </BaseModal>
  );
}